import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} - Socialine`
      : "Socialine - Social Casino Entertainment";
  }, [title]);
};